import { gql } from "lib/apolloClient";
import { unitFlowItemFragment } from "./Fragments";

export const getUnitCombinedLibraryQuery = gql`
  query getUnitCombinedLibrary(
    $parentId: ID!
    $filters: EntityFlowResourceFilter
    $after: String
    $first: Int
  ) {
    node(id: $parentId, type: UNIT_PLAN) {
      id
      ... on UnitPlan {
        id
        unitFlowFeed {
          unitFlowId
          unitResourceId
          unitFlowFlatFeed(
            orderBy: CREATED_AT
            filters: $filters
            orderByDirection: DESC
            after: $after
            first: $first
          ) {
            edges {
              node {
                ...unitFlowItem
              }
            }
            pageInfo {
              hasNextPage
              hasPreviousPage
              startCursor
              endCursor
              __typename
            }
            resourceBasedCount {
              totalCount
              __typename
            }
          }
        }
        __typename
      }
    }
  }
  ${unitFlowItemFragment}
`;
